import { JobSiteMap } from './JobSiteMap';

interface SiteAddressCardProps {
  address: string;
  city?: string;
  province?: string;
  postalCode?: string;
  parkingInstructions?: string;
}

export const SiteAddressCard = ({ address, city, province, postalCode, parkingInstructions }: SiteAddressCardProps) => {
  const handleViewOnMap = () => {
    // Build full address for map
    const fullAddress = [address, city, province, postalCode].filter(Boolean).join(', ');
    const encodedAddress = encodeURIComponent(fullAddress);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  return (
    <div className="bg-white p-3.5 rounded-xl border border-gray-200">
      <h3 className="text-sm font-bold text-gray-900 mb-2">Site Address</h3>
      <div className="space-y-2 text-sm text-gray-600">
        {address && (
          <p className="flex items-start gap-2">
            <span className="material-symbols-outlined text-base mt-0.5">location_on</span>
            <span>
              {address}
              {city && (
                <>
                  <br />
                  {city}{province && `, ${province}`}
                  {postalCode && (
                    <>
                      <br />
                      {postalCode}
                    </>
                  )}
                </>
              )}
            </span>
          </p>
        )}
        
        {parkingInstructions && (
          <p className="flex items-start gap-2 pt-2 border-t border-gray-200">
            <span className="material-symbols-outlined text-base mt-0.5">local_parking</span>
            <span>
              <strong className="block text-gray-700 mb-1">Parking:</strong>
              {parkingInstructions}
            </span>
          </p>
        )}
        
        {address && (
          <button
            onClick={handleViewOnMap}
            className="flex items-center gap-2 text-primary hover:underline pt-2"
          >
            <span className="material-symbols-outlined text-base">map</span>
            View on Map
          </button>
        )}

        {address && (
          <JobSiteMap address={[address, city, province, postalCode].filter(Boolean).join(', ')} />
        )}
      </div>
    </div>
  );
};


